import {call, put, select} from "redux-saga/effects";
import {setLoading, setMetaResult, setResult} from "../../slices/dynamicMultipleElementsSlice";
import {
    getFeaturedList,
  getFlashSale,
  getFlashSaleProductList,
  getProductList,
  getSpecialList
} from "../requests/productService";
import { appendUtcTimeZone, parseProductTypeFromUrl } from 'helpers/helperFunctions'
import { PRODUCT_LIST_TYPE } from '../../../constants/commons'

export function* handleGetProductList({payload: {type, value}}) {
  const element = 'products';
  const elementType = `${type}-${value}`;
  try {
    yield put(setLoading({element, loading: true, id: elementType}));
    const state = yield select((state) => state.dynamicMultipleElements[element][elementType]);

    let _type = "", _value = "", _filterBy = {};

    if(type === PRODUCT_LIST_TYPE.OTHER){
      //https://uat.jvtests.com/products/search?query=sfas
      //https://uat.jvtests.com/products/categories/leggings-set-849
      //https://uat.jvtests.com/products/brands/aadhya-1143
      //https://uat.jvtests.com/product-campaigns/most-searched-products-feb-updated-5074
       const _typeValue = parseProductTypeFromUrl(value)
     _type = _typeValue.type
     _value = _typeValue.value
     _filterBy = _typeValue.params
      console.log(_typeValue);
    }else{
      _type = type
      _value = value
    }

    if (!_type || !_value) {
      yield put(setResult({
        data: [], element, hasNext: false, page: 1,
        totalResults: 0, id: elementType,
      }))
    }

    const {data: {page, has_next: hasNext, total_results: totalResults, data}}
      = yield call(() => getProductList({page: (state?.page ?? 0) + 1, type:_type, value: _value, filterBy: _filterBy}));
    yield put(setResult({
      data, element, hasNext, page,
      totalResults, id: elementType
    }));

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}

export function* handleGetHotSpecialList(action) {
  const element = 'products';
  const elementType = 'hotSpecial';
  try {
    yield* handleGetSpecialList(action, element, elementType);

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}

export function* handleGetFreshSpecialList(action) {
  const element = 'products';
  const elementType = 'freshSpecial';
  try {
    yield* handleGetSpecialList(action, element, elementType, false);

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}

export function* handleGetFeaturedList(action) {
  const element = 'products';
  const elementType = 'featured';
  try {
    yield put(setLoading({element, loading: true, id: elementType}));
    const state = yield select((state) => state.dynamicMultipleElements[element][elementType]);

    const {data: {page, has_next: hasNext, total_results: totalResults, data, images}}
      = yield call(() => getFeaturedList(state.page + 1));
    yield put(setResult({
      data, element, hasNext, page,
      totalResults, id: elementType, ...((images && images.length) && {meta: images[0]})
    }));

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}

function* handleGetSpecialList(action, element, elementType, isHot = true) {
  try {
    yield put(setLoading({element, loading: true, id: elementType}));
    const state = yield select((state) => state.dynamicMultipleElements[element][elementType]);

    const {data: {page, has_next: hasNext, total_results: totalResults, data, images}}
      = yield call(() => getSpecialList(state.page + 1, isHot));
    yield put(setResult({
      data, element, hasNext, page,
      totalResults, id: elementType, ...((images && images.length) && {meta: images[0]})
    }));

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}

export function* handleGetFlashSaleList() {
  const element = 'products';
  const elementType = 'flashSale';
  try {
    yield put(setLoading({element, loading: true, id: elementType}));

    const state = yield select((state) => state.dynamicMultipleElements[element][elementType]);
    let flashSaleInfo = state.meta;
    if (!flashSaleInfo?.id) {
      flashSaleInfo = yield call(() => getFlashSale());
      if (flashSaleInfo)
        yield put(setMetaResult({
          data: {...flashSaleInfo, endsIn: appendUtcTimeZone(flashSaleInfo.ending)},
          element,
          id: elementType
        }));
    }

    if (flashSaleInfo?.id) {
      const {data: {page, has_next: hasNext, total_results: totalResults, data}}
        = yield call(() => getFlashSaleProductList(state.page + 1, flashSaleInfo.id));
      yield put(setResult({
        data, element, hasNext, page,
        totalResults, id: elementType
      }));
    } else {
      yield put(setResult({
        data: [], element, hasNext: false, page: 0,
        totalResults: 0, id: elementType
      }));
    }

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: elementType}));
  }
}
